import { render, staticRenderFns } from "./Hdzs.vue?vue&type=template&id=25563ce8&scoped=true&"
import script from "./Hdzs.vue?vue&type=script&lang=js&"
export * from "./Hdzs.vue?vue&type=script&lang=js&"
import style0 from "./Hdzs.vue?vue&type=style&index=0&id=25563ce8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25563ce8",
  null
  
)

export default component.exports